<template>
  <div class="xieyi">
    <div class="title">项目合作协议</div>
    <div class="fir tops">
      人人动画网（包括网址为www.quiuk3D.com的网站，以及可在IOS 系统及Android 系统中运行的名为“人人动画”的应用程序，以下简称"本网站"或“人人动画”）由北京超视界科技有限公司（包括其关联机构，以下合称“本公司”）运营并享有完全的所有权及知识产权等权益，本网站提供的服务将完全按照其发布的条款和操作规则严格执行。您确认同意本协议所有条款并完成注册程序时，本协议在您与本公司间成立并发生法律效力，同时您成为本网站正式合作用户。
    </div>
    <!-- <div class="fir">委托方（甲方）：</div> -->
    <!-- <div class="fir">受托方（乙方）：</div> -->

    <div class="fir bot">依据《中华人民共和国合同法》的有关规定，协议双方本着自愿、公平、诚实、信用、有偿的原则，经友好协商，就美术设计/模型/渲染/动画制作/特效制作（以下统称为作品）一事达成以下协议：</div>

    <div class="f-tit">一．委托的内容、要求</div>
    <p>1．内容：按照甲方要求制作美术设计/模型/渲染/动画制作/特效制作。</p>
    <p>2．制作要求：制作效果须达到播出要求，符合动画行业内质量标准。</p>
    <p>3．完成时间： 按照甲方要求的时间进度完成甲方委托的工作。</p>
    <p>4．乙方最终向甲方提交的资料：符合甲方要求的工程文件和最终作品。</p>

    <div class="f-tit">二．甲方的权利与责任</div>
    <p>1．委托乙方制作的作品甲方享有全部版权和著作权。</p>
    <p>2．甲方提供乙方设计所需的文字脚本、项目所需素材等。</p>
    <p>3．甲方有权知晓乙方工作进度，若乙方不能按约定时间及进度完成工作，甲方有权终止合同。</p>
    <p>4． 甲方及时完成校对和提出修改意见。</p>
    <p>5． 如乙方未积极按照建议进行修改，甲方有权提出终止合作。</p>
    <p>6． 全部工作完成后,经甲方验收合格，按照协议中的付款方式支付全部费用。</p>

    <div class="f-tit">三．乙方的权利与责任</div>
    <p>1．乙方愿接受甲方委托并保证按时、按要求、高质量完成。</p>
    <p>2．乙方保证其设计过程、设计方案及相关工作成果不侵犯任何第三方的知识产权，并承诺对因上述成果，非甲方原因的，如侵害第三方的合法权益导致的索赔承担赔偿责任。</p>
    <p>3．未经甲方同意严禁将文字、图片或部分形象提供给第三方，如因此给甲方带来损失及影响，乙方将负全部责任并赔偿由此给甲方造成的全部损失，承担相应的法律责任。</p>
    <p>4．制作过程中，对甲方提出的合理修改建议，应积极配合。甲方可要求无偿修改三次。</p>
    <p>5．乙方在项目制作完成，甲方全部结款后，乙方应将全部源文件移交甲方。</p>

    <div class="f-tit">四．费用标准及付款方式</div>
    <p>1．制作费： 甲乙双方就具体委托内容协商。</p>
    <p>2．付款方式：严格按照工作进度按时按质完成，即交付作品甲方验收合格支付70%，甲方使用乙方作品的作品完成，支付相应剩余全部费用（30%）。</p>

    <div class="f-tit">五．保密条款</div>
    <p>1．本协议履行过程中，甲方提供给乙方的资料，乙方应予以保密。凡因业务需要，甲方所告知乙方之任何信息及资料，均在此保密条款之约束范围内，乙方不得以任何形式自行使用或向第三方泄漏。</p>
    <p>2．项目执行完毕后，即乙方应将全部源文件移交甲方后。</p>
    <p>3．未经甲方同意，乙方不得擅自对外发布与本项目有关的任何信息。</p>

    <div class="f-tit">六．违约责任</div>
    <p>1．双方在签署合同前应明确双方的权利与义务，合同签署后应严格按照本合同执行。</p>
    <p>2．双方要严格按照约定时间完成作品制作，如因甲方原因造成的工程延误，乙方不承担违约责任，完工日期相应顺延。如因乙方原因不能按时完成，完工日期亦可顺延，但总体完成时间不超出甲方规定时间2天。</p>
    <p>3．若甲方违反合同条款，乙方有权终止合同，并要求甲方支付合同总价10％的违约金。同样，若乙方违反合同条款，甲方有权终止合同，并要求乙方支付合同总价10％的违约金。</p>
    <p>4．由于不可抗力的原因（灾害、战争等）造成合同的部分不能履行，双方协商解决，在此期间造成的各种情况，乙方可不负法律责任。</p>

    <div class="f-tit">七．合作意向中未尽事宜，双方共同协商友好解决。</div>
    <!-- <div class="f-tit">八．本协议一式两份，双方各执一份，自双方签字之日起生效。</div> -->

    <!-- <div class="qianzi-gaizhang clearfix">
      <div class="item">
        <span>甲 方（盖章）：</span>
        <span>（签字）：</span>
        <span>地 址：</span>
        <span>电 话：</span>
      </div>
      <div class="item">
        <span>乙方：</span>
        <span>身份证号码：</span>
        <span>住址：</span>
        <span>电话：</span>
      </div>
    </div> -->
  </div>
</template>

<script type="text/ecmascript-6">
export default {
  components: {

  },
  data () {
    return {

    }
  }
}
</script>

<style scoped lang="less">
.xieyi{
  line-height: 30px;
  font-size: 14px;
  .title{
    margin-bottom: 20px;
    font-size: 30px;
    text-align: center;
    font-weight: bold;
  }
  .fir{
    text-indent: 28px;
    font-size: 16px;
    font-weight: bold;
    &.tops{
      margin-bottom: 10px;
    }
    &.bot{
      margin-top: 10px;
    }
  }
  .f-tit{
    margin: 10px 0 5px;
    font-size: 16px;
    text-indent: 28px;
    font-weight: bold;
  }
  p{
    margin: 5px 0;
    line-height: 24px;
    text-indent: 28px;
    &.p{
      margin: 10px 0;
      font-size: 15px;
      font-weight: bold;
    }
  }
}
.qianzi-gaizhang{
  margin-top: 20px;
  .item{
    float: left;
    padding-left: 40px;
    width: 50%;
  }
  span{
    display: block;
    margin-bottom: 10px;
    font-size: 16px;
  }
}
@media screen and (max-width: 750px) {
  .qianzi-gaizhang{
    .item{
      padding-left: 10px;
    }
    span{
      font-size: 14px;
    }
  }
}
@media screen and (min-width: 751px) {
  .xieyi{
    padding: 0 40px;
  }
}
@media screen and (min-width: 1370px) {
  .xieyi{
    padding: 0 80px;
  }
}
</style>
